import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import Chatbot from "../Chatbot";
import { trackCTA } from "../../utils/analytics";

const Services = () => {
  const [selectedService, setSelectedService] = useState(null);
  const [activeTab, setActiveTab] = useState('overview');

  const serviceDetails = {
    "Conducting Workshops": [
      "Cybersecurity (Specialized VAPT, SOC, GRC & Corporate Networking)",
      "AI & ML (AIML)",
      "Agentic AI",
      "Design Thinking",
      "Cloud Computing",
      "Soft Skills, Python",
      "Java",
      "Database - SQL, etc."
    ],
    // Duplicate key to align with card title
    "Workshops": [
      "Cybersecurity (Specialized VAPT, SOC, GRC & Corporate Networking)",
      "AI & ML (AIML)",
      "Agentic AI",
      "Design Thinking",
      "Cloud Computing",
      "Soft Skills, Python",
      "Java",
      "Database - SQL, etc."
    ],
    "Exclusive Training": [
      "Cybersecurity (Specialized VAPT, SOC, GRC & Corporate Networking)",
      "AI & ML (AIML)",
      "Python",
      "Java",
      "Database - SQL, etc.",
      "ERP (SAP)",
      "Legal Literacy (LLB/BL)"
    ],
    // Duplicate key to align with card title
    "Exclusive Training (Online/Offline)": [
      "Cybersecurity (Specialized VAPT, SOC, GRC & Corporate Networking)",
      "AI & ML (AIML)",
      "Python",
      "Java",
      "Database - SQL, etc.",
      "ERP (SAP)",
      "Legal Literacy (LLB/BL)"
    ],
    "Guidance & Mentoring": [
      "Internships: Guidance on finding and preparing for internships that match the student’s interests and career goals",
      "Career Mentoring: One-on-one mentoring to help students identify strengths, set goals, and plan their career path",
      "Industry Connections: Opportunities to interact with industry professionals through talks, sessions, and networks",
      "Stress Management: Support and strategies to manage academic and career-related stress effectively"
    ],
    "Career Guidance for School Students": [
      "8th–10th: Explain available streams after 10th (Science, Commerce, Arts & Humanities, Vocational & Skill‑based) in simple, practical terms",
      "Help students understand what kind of subjects and careers are linked to each stream",
      "After 12th: Explain undergraduate & postgraduate options such as B.Tech, B.Com, BBA, B.Sc, M.Tech, M.Com, MBA and more",
      "Sessions conducted with both students and parents so that decisions are aligned with the child’s interests and strengths",
      "Encourage students to explore interests early instead of following only traditional options like Engineering or Medicine"
    ],
    "AI with Python Training": [
      "Machine Learning Fundamentals: Comprehensive introduction to ML concepts, algorithms, and practical implementation using Python libraries like scikit-learn, pandas, and numpy",
      "Linear Regression Deep Dive: Hands-on training starting with Linear Regression for predicting continuous values, including feature engineering, model evaluation, and interpretation of results",
      "Data Science Pipeline: Complete workflow from data collection and preprocessing to model training, validation, and deployment using real-world datasets and industry-standard tools",
      "AI Model Deployment: Learn to deploy machine learning models using Flask, FastAPI, and cloud platforms like AWS, Azure, or Google Cloud for production-ready applications",
      "Advanced AI Topics: Explore deep learning with TensorFlow/PyTorch, natural language processing, computer vision, and recommendation systems for comprehensive AI expertise"
    ],
    "No-Code/Low-Code Development": [
      "Glide and Bubble: Build apps visually with powerful data bindings and responsive components",
      "Platform Integration: Connect Glide/Bubble apps with APIs and databases",
      "API Integration Training: Connect visual interfaces with backend services and third‑party APIs",
      "Rapid Prototyping: Build functional prototypes and MVPs quickly using visual tools",
      "Workflow Automation: Create automated workflows and business processes using no-code platforms"
    ],
    "Complete Development Services": [
      "Website Development: Modern, responsive websites built with React, Next.js, and other cutting-edge technologies, optimized for performance and SEO",
      "Product Development: End-to-end product development from concept to deployment, including UI/UX design, backend development, and cloud infrastructure setup",
      "AI Development: Custom AI solutions including chatbots, recommendation systems, predictive analytics, and machine learning models tailored to business needs",
      "Mobile-First Design: Responsive web applications and progressive web apps (PWAs) that work seamlessly across all devices and screen sizes",
      "Cloud Deployment: Complete cloud infrastructure setup and deployment using AWS, Azure, or Google Cloud, including CI/CD pipelines and monitoring solutions"
    ]
  };

  const openModal = (serviceTitle) => {
    setSelectedService(serviceTitle);
    setActiveTab('overview');
  };

  const closeModal = () => {
    setSelectedService(null);
    setActiveTab('overview');
  };

  return (
    <div className="services">
      {/* Hero Section */}
      <section className="relative bg-gradient-to-r from-jnanakshi-500 via-jnanakshi-400 to-jnanakshi-600 text-white pt-16 sm:pt-20 overflow-hidden">
        {/* Subtle background image overlay */}
        <div
          className="absolute inset-0 bg-center bg-cover opacity-15 mix-blend-overlay pointer-events-none"
          style={{
            backgroundImage:
              "url('/images/services-hero-overlay.jpg')"
          }}
        />
        <div className="max-w-7xl mx-auto px-3 sm:px-4 md:px-6 lg:px-8 py-12 sm:py-16 lg:py-20">
          <div className="text-center">
            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-extrabold leading-tight">
              Our Services
            </h1>
            <p className="mt-4 sm:mt-6 text-base sm:text-lg md:text-xl text-gray-200 max-w-4xl mx-auto">
              Discover our comprehensive range of live workshops, AI training, no-code development, and complete development services designed to
              bridge the gap between academic knowledge and professional competence.
            </p>
            {/* Delivery Modes & Mentoring Badges */}
            <div className="mt-5 sm:mt-6 flex flex-wrap gap-2 justify-center">
              <span className="inline-flex items-center px-3 py-1 rounded-full bg-white/15 backdrop-blur text-xs sm:text-sm font-semibold">
                Online & Offline Training
              </span>
              <span className="inline-flex items-center px-3 py-1 rounded-full bg-white/15 backdrop-blur text-xs sm:text-sm font-semibold">
                Individual Mentoring Available
              </span>
            </div>
          </div>
        </div>

        {/*WAVES*/}
        <div className="absolute bottom-0 left-0 w-full overflow-hidden leading-[0] rotate-180">
          <svg
            className="relative block w-[calc(100%+1.3px)] h-[111px]"
            viewBox="0 0 1200 120"
            preserveAspectRatio="none"
          >
            <path
              d="M0,0V46.29c47.79,22.2,103.59,32.17,158,28,70.36-5.37,136.33-33.31,206.8-37.5C438.64,32.43,512.34,53.67,583,72.05c69.27,18,138.3,24.88,209.4,13.08,36.15-6,69.85-17.84,104.45-29.34C989.49,25,1113-14.29,1200,52.47V0Z"
              className="fill-white opacity-25"
            ></path>
            <path
              d="M0,0V15.81C13,36.92,27.64,56.86,47.69,72.05,99.41,111.27,165,111,224.58,91.58c31.15-10.15,60.09-26.07,89.67-39.8,40.92-19,84.73-46,130.83-49.67,36.26-2.85,70.9,9.42,98.6,31.56,31.77,25.39,62.32,62,103.63,73,40.44,10.79,81.35-6.69,119.13-24.28s75.16-39,116.92-43.05c59.73-5.85,113.28,22.88,168.9,38.84,30.2,8.66,59,6.17,87.09-7.5,22.43-10.89,48-26.93,60.65-49.24V0Z"
              className="fill-white opacity-50"
            ></path>
            <path
              d="M0,0V5.63C149.93,59,314.09,71.32,475.83,42.57c43-7.64,84.23-20.12,127.61-26.46,59-8.63,112.48,12.24,165.56,35.4C827.93,77.22,886,95.24,951.2,90c86.53-7,172.46-45.71,248.8-84.81V0Z"
              className="fill-gray-50"
            ></path>
          </svg>
        </div>
      </section>

      {/* Services Grid */}
      <section className="bg-gray-50 dark:bg-dark-800 py-12 sm:py-16 lg:py-20 transition-colors duration-300">
        <div className="max-w-7xl mx-auto px-3 sm:px-4 md:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 lg:gap-8 items-stretch">
            {[
              {
                title: "Workshops",
                description: "Immersive, live workshops led by seasoned industry experts.",
                image: "/images/services-workshops.jpg",
                features: [
                  "Cybersecurity (Specialized VAPT, SOC, GRC & Corporate)",
                  "AI & ML (AIML)",
                  "Agentic AI",
                  "Design Thinking",
                  "Cloud Computing",
                  "Soft Skills, Python",
                  "Java",
                  "Database - SQL, etc."
                ]
              },
              {
                title: "Exclusive Training (Online/Offline)",
                description: "Focused training programs tailored for in‑depth skill building.",
                image: "/images/services-exclusive.jpg",
                features: [
                  "Cybersecurity (Specialized VAPT, SOC, GRC & Corporate)",
                  "AI & ML (AIML)",
                  "Python",
                  "Java",
                  "Database - SQL, etc.",
                  "ERP (SAP)",
                  "Legal Literacy (LLB/BL)"
                ]
              },
              {
                title: "Guidance & Mentoring",
                description: "Personalized mentoring to help students secure internships and prepare for careers.",
                image: "/images/services-mentoring.jpg",
                features: [
                  "Internships",
                  "Career Mentoring",
                  "Industry Connections",
                  "Stress Management"
                ]
              },
              {
                title: "Career Guidance for School Students",
                description: "Structured career guidance for students from 8th to 12th grade, with dedicated sessions for students and parents.",
                image: "/images/home-feature-career.jpg",
                features: [
                  "8th–10th: Stream awareness (Science, Commerce, Arts & Humanities, Vocational & Skill‑based)",
                  "After 12th: UG & PG pathways (B.Tech, B.Com, BBA, B.Sc, M.Tech, M.Com, MBA, etc.)",
                  "One‑to‑one and group guidance sessions",
                  "Sessions designed for both students and parents"
                ]
              },
              {
                title: "AIML Training",
                description: "AI/ML curriculum offered in Basic and Advanced tracks.",
                image: "/images/services-python-ai.jpg",
                features: [
                  "Basic AI: Machine Learning fundamentals",
                  "Advanced AI: Deep Learning and Generative AI",
                  "Modes: Online & Offline Training"
                ]
              },
              {
                title: "No-Code/Low-Code Development",
                description: "Build applications faster using no-code platforms like Glide and Bubble.",
                image: "/images/services-nocode.jpg",
                features: [
                  "Glide App Development",
                  "Bubble App Development",
                  "API Integration Training",
                  "Rapid Prototyping"
                ]
              },
              {
                title: "Development Services",
                description: "End-to-end development solutions from concept to deployment.",
                image: "/images/services-development.jpg",
                features: [
                  "Website Development",
                  "Product Development",
                  "AI Development",
                  "Cloud Deployment",
                  "Engagements: Remote & Onsite"
                ]
              }
            ].map((service, index) => (
              <div key={index} className="bg-white dark:bg-dark-700 rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-all duration-300 h-full flex flex-col transform hover:-translate-y-1 transition-colors duration-300">
                <div className="p-4 sm:p-6 flex-1">
                  <img src={service.image} alt={service.title} className="w-full h-36 object-cover rounded-md mb-3 sm:mb-4" loading="lazy" />
                  <h3 className="text-lg sm:text-xl font-bold text-gray-800 dark:text-white mb-2 sm:mb-3">{service.title}</h3>
                  <p className="text-gray-600 dark:text-gray-300 mb-3 sm:mb-4 text-sm sm:text-base">{service.description}</p>
                  <ul className="space-y-1 sm:space-y-2">
                    {service.features.map((feature, featureIndex) => (
                      <li key={featureIndex} className="flex items-center text-xs sm:text-sm text-gray-600 dark:text-gray-300">
                        <span className="text-jnanakshi-500 dark:text-jnanakshi-400 mr-2">✓</span>
                        {feature}
                      </li>
                    ))}
                  </ul>
                </div>
                <div className="bg-gradient-to-r from-jnanakshi-500 to-jnanakshi-600 p-3 sm:p-4">
                  <button
                    onClick={() => { trackCTA('service_learn_more', { service: service.title }); openModal(service.title); }}
                    className="w-full text-white font-semibold hover:bg-white hover:text-jnanakshi-600 transition py-2 rounded text-sm sm:text-base"
                  >
                    Learn More
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Enhanced Modal */}
      {selectedService && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-2 sm:p-4">
          <div className="bg-white dark:bg-dark-700 rounded-lg max-w-4xl w-full max-h-[90vh] sm:max-h-[85vh] overflow-hidden transition-colors duration-300">
            {/* Modal Header */}
            <div className="bg-gradient-to-r from-jnanakshi-500 to-jnanakshi-600 text-white p-4 sm:p-6">
              <div className="flex justify-between items-center">
                <h3 className="text-xl sm:text-2xl md:text-3xl font-bold pr-2">{selectedService}</h3>
                <button
                  onClick={closeModal}
                  className="text-white hover:text-gray-200 text-2xl sm:text-3xl font-bold flex-shrink-0"
                >
                  ×
                </button>
              </div>

              {/* Tab Navigation */}
              <div className="mt-4 flex space-x-1">
                {[
                  { id: 'overview', label: 'Overview' },
                  { id: 'contact', label: 'Get Started' }
                ].map((tab) => (
                  <button
                    key={tab.id}
                    onClick={() => setActiveTab(tab.id)}
                    className={`px-3 py-2 rounded-lg text-sm font-medium transition-colors ${activeTab === tab.id
                      ? 'bg-white text-jnanakshi-600'
                      : 'text-white hover:bg-white/20'
                      }`}
                  >
                    {tab.label}
                  </button>
                ))}
              </div>
            </div>

            {/* Modal Content */}
            <div className="p-4 sm:p-6 max-h-[60vh] overflow-y-auto">
              {activeTab === 'overview' && (
                <div className="space-y-4">
                  <h4 className="text-lg font-semibold text-gray-800 dark:text-white mb-3">Available Options</h4>
                  <p className="text-gray-600 dark:text-gray-400 text-sm mb-4">
                    Choose from our comprehensive range of {selectedService.toLowerCase()}. Contact us to learn more about specific courses and get detailed information.
                  </p>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                    {serviceDetails[selectedService]?.map((detail, index) => (
                      <div key={index} className="flex items-start gap-3 p-3 bg-gray-50 dark:bg-dark-600 rounded-lg">
                        <span className="text-jnanakshi-600 dark:text-jnanakshi-400 mt-1 flex-shrink-0">✓</span>
                        <p className="text-gray-700 dark:text-gray-300 text-sm leading-relaxed">{detail}</p>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* Career Roadmap and Course Content tabs removed as per requirements */}

              {activeTab === 'contact' && (
                <div className="space-y-4">
                  <h4 className="text-lg font-semibold text-gray-800 dark:text-white mb-3">Ready to Get Started?</h4>
                  <div className="bg-green-50 dark:bg-green-900/20 p-4 rounded-lg">
                    <p className="text-gray-700 dark:text-gray-300 text-sm leading-relaxed mb-4">
                      Contact us to learn more about this {selectedService.toLowerCase()} and get detailed information about:
                    </p>
                    <ul className="space-y-2 mb-4">
                      <li className="flex items-start gap-2">
                        <span className="text-green-600 dark:text-green-400 mt-1">•</span>
                        <span className="text-gray-700 dark:text-gray-300 text-sm">Detailed curriculum and course structure</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <span className="text-green-600 dark:text-green-400 mt-1">•</span>
                        <span className="text-gray-700 dark:text-gray-300 text-sm">Schedule and duration options</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <span className="text-green-600 dark:text-green-400 mt-1">•</span>
                        <span className="text-gray-700 dark:text-gray-300 text-sm">Pricing and enrollment process</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <span className="text-green-600 dark:text-green-400 mt-1">•</span>
                        <span className="text-gray-700 dark:text-gray-300 text-sm">Prerequisites and skill requirements</span>
                      </li>
                    </ul>
                    <div className="flex flex-col sm:flex-row gap-3">
                      <a
                        href="tel:+917760556768"
                        className="flex items-center justify-center gap-2 px-4 py-2 bg-jnanakshi-500 text-white rounded-lg hover:bg-jnanakshi-600 transition text-sm font-medium"
                      >
                        <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                          <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
                        </svg>
                        Call: +91 7760556768
                      </a>
                      <a
                        href="mailto:support@jnanakshi.com"
                        className="flex items-center justify-center gap-2 px-4 py-2 bg-gray-500 text-white rounded-lg hover:bg-gray-600 transition text-sm font-medium"
                      >
                        <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                          <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                          <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                        </svg>
                        Email: support@jnanakshi.com
                      </a>
                    </div>
                  </div>
                </div>
              )}
            </div>

            {/* Modal Footer */}
            <div className="bg-gray-50 dark:bg-dark-600 px-4 sm:px-6 py-3 flex justify-end">
              <button
                onClick={closeModal}
                className="px-4 py-2 bg-gray-500 text-white rounded-lg hover:bg-gray-600 transition text-sm font-medium"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Footer Component */}
      <footer className="bg-gray-800 dark:bg-dark-800 text-white py-8 sm:py-10 lg:py-12 transition-colors duration-300">
        <div className="max-w-7xl mx-auto px-3 sm:px-4 md:px-6 lg:px-8">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
            {/* About Section */}
            <div className="sm:col-span-2 lg:col-span-1">
              <h3 className="text-lg sm:text-xl font-semibold mb-3 sm:mb-4">About Jnanakshi Solutions</h3>
              <p className="text-gray-400 dark:text-gray-300 text-sm sm:text-base leading-relaxed">
                At Jnanakshi Solutions, we are committed to bridging the critical gap between academic knowledge
                and professional competence. We specialize in providing immersive live workshops and targeted
                training programs designed to empower college students and transform them into industry-ready professionals.
              </p>
            </div>

            {/* Quick Links */}
            <div>
              <h3 className="text-lg sm:text-xl font-semibold mb-3 sm:mb-4">Quick Links</h3>
              <ul className="space-y-2">
                <li>
                  <NavLink
                    to="/about-us"
                    className="text-gray-400 dark:text-gray-300 hover:text-white transition text-sm sm:text-base"
                  >
                    About Us
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/services"
                    className="text-gray-400 dark:text-gray-300 hover:text-white transition text-sm sm:text-base"
                  >
                    Services
                  </NavLink>
                </li>
              </ul>
            </div>

            {/* Contact Info */}
            <div>
              <h3 className="text-lg sm:text-xl font-semibold mb-3 sm:mb-4">Contact Us</h3>
              <p className="text-gray-400 dark:text-gray-300 text-sm sm:text-base">
                <strong>Address:</strong> Bangalore, India
              </p>
              <p className="text-gray-400 dark:text-gray-300 text-sm sm:text-base mt-2">
                <strong>Phone:</strong> +91 7760556768
              </p>
              <p className="text-gray-400 dark:text-gray-300 text-sm sm:text-base mt-2">
                <strong>Email:</strong> support@jnanakshi.com
              </p>
            </div>
          </div>

          <div className="mt-8 sm:mt-10 border-t border-gray-700 dark:border-dark-600 pt-4 sm:pt-6 flex flex-col sm:flex-row justify-between items-center gap-4">
            {/* Social Media Links */}
            <div className="flex space-x-4 sm:space-x-6">
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 dark:text-gray-300 hover:text-white transition text-lg sm:text-xl"
              >
                <i className="fab fa-facebook-f"></i>
              </a>
              <a
                href="https://twitter.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 dark:text-gray-300 hover:text-white transition text-lg sm:text-xl"
              >
                <i className="fab fa-twitter"></i>
              </a>
              <a
                href="https://linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 dark:text-gray-300 hover:text-white transition text-lg sm:text-xl"
              >
                <i className="fab fa-linkedin-in"></i>
              </a>
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 dark:text-gray-300 hover:text-white transition text-lg sm:text-xl"
              >
                <i className="fab fa-instagram"></i>
              </a>
            </div>

            {/* Copyright */}
            <p className="text-gray-400 dark:text-gray-300 text-xs sm:text-sm text-center sm:text-right">
              &copy; {new Date().getFullYear()} Jnanakshi Solutions. All rights reserved.
            </p>
          </div>
        </div>
      </footer>

      {/* Chatbot Component */}
      <Chatbot />
    </div>
  );
};

export default Services;
